/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AclBuildModel } from '../models/AclBuildModel';
import type { AutomotiveRequestMethod } from '../models/AutomotiveRequestMethod';
import type { BranchType } from '../models/BranchType';
import type { GetEnquiryResponse } from '../models/GetEnquiryResponse';
import type { UpdateHandoverRequest } from '../models/UpdateHandoverRequest';
import type { UpdateQuestionsRequest } from '../models/UpdateQuestionsRequest';
import type { UpdateRecommendationsRequest } from '../models/UpdateRecommendationsRequest';
import type { UserStatusResponse } from '../models/UserStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AclService {

  /**
   * @param dealId 
   * @returns AclBuildModel Success
   * @throws ApiError
   */
  public static getAclDeals(
dealId: number,
): CancelablePromise<AclBuildModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/deals/{dealId}',
      path: {
        'dealId': dealId,
      },
    });
  }

  /**
   * @returns UserStatusResponse Success
   * @throws ApiError
   */
  public static getAclUsersStatus(): CancelablePromise<UserStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/users/status',
    });
  }

  /**
   * @param uid 
   * @returns UserStatusResponse Success
   * @throws ApiError
   */
  public static getAclUsersStatus1(
uid: string,
): CancelablePromise<UserStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/users/status/{uid}',
      path: {
        'uid': uid,
      },
    });
  }

  /**
   * @param requestId 
   * @returns any Success
   * @throws ApiError
   */
  public static getAclRequests(
requestId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/requests/{requestId}',
      path: {
        'requestId': requestId,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param requestMethod
 *
 * 1 = CreateEnquiry
 *
 * 2 = GetEnquiry
 *
 * 3 = GetQuestions
 *
 * 4 = UpdateQuestions
 *
 * 5 = GetRecoms
 *
 * 6 = UpdateRecoms
 *
 * 7 = SendSms
 *
 * 8 = ConfirmSms
 *
 * 9 = UpdateHandover
 *
 * 10 = GetHandover
 *
 * 11 = GetUserStatus
   * @param json 
   * @param overridenBranchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns number Created
   * @throws ApiError
   */
  public static postAclRequests(
enquiryId?: number,
requestMethod?: AutomotiveRequestMethod,
json?: string,
overridenBranchId?: BranchType,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/requests',
      query: {
        'enquiryId': enquiryId,
        'requestMethod': requestMethod,
        'json': json,
        'overridenBranchId': overridenBranchId,
      },
    });
  }

  /**
   * @param dealId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postAclEnquiries(
dealId?: number,
requestBody?: GetEnquiryResponse,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries',
      query: {
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param enquiryId 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesDdiSend(
enquiryId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/ddi/send',
      path: {
        'enquiryId': enquiryId,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param reason 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesDdiReject(
enquiryId: number,
reason?: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/ddi/reject',
      path: {
        'enquiryId': enquiryId,
      },
      query: {
        'reason': reason,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param mobilePhone 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesSmsSend(
enquiryId: number,
mobilePhone?: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/sms/send',
      path: {
        'enquiryId': enquiryId,
      },
      query: {
        'mobilePhone': mobilePhone,
      },
    });
  }

  /**
   * @param enquiryId 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesQuestionsGet(
enquiryId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/questions/get',
      path: {
        'enquiryId': enquiryId,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesQuestionsUpdate(
enquiryId: number,
requestBody?: UpdateQuestionsRequest,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/questions/update',
      path: {
        'enquiryId': enquiryId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param enquiryId 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesRecommendationsGet(
enquiryId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/recommendations/get',
      path: {
        'enquiryId': enquiryId,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesRecommendationsUpdate(
enquiryId: number,
requestBody?: UpdateRecommendationsRequest,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/recommendations/update',
      path: {
        'enquiryId': enquiryId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param enquiryId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postAclEnquiriesHandoverUpdate(
enquiryId: number,
requestBody?: UpdateHandoverRequest,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries/{enquiryId}/handover/update',
      path: {
        'enquiryId': enquiryId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
